import { NAV_LINKS } from "../data";

export const Footer = () => (
  <footer data-testid="footer" className="border-t border-line bg-[#F4F6F0] py-14">
    <div className="mx-auto max-w-7xl px-6 md:px-8">
      <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr]">
        <div>
          {/* Real XSELL Solutions logo — transparent */}
          <a href="#top" className="inline-flex items-center">
            <img src="/xsell-logo-light.png" alt="XSell Solutions — Your Partner in Growth" className="h-14 w-auto" />
          </a>
          <p className="mt-4 max-w-xs text-sm leading-relaxed text-[#5f6857]">
            GTM strategy & revenue consulting — engineering enterprise revenue for technology and
            B2B services firms.
          </p>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#8e9882]">Navigate</p>
          <ul className="mt-4 space-y-2.5">
            {NAV_LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-[#586150] transition-colors hover:text-[#5C8A1E]">{l.label}</a>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-xs font-semibold uppercase tracking-[0.18em] text-[#8e9882]">Explore</p>
          <ul className="mt-4 space-y-2.5">
            <li><a href="#framework" className="text-sm text-[#586150] transition-colors hover:text-[#5C8A1E]">The 5-Pillar Framework</a></li>
            <li><a href="#process" className="text-sm text-[#586150] transition-colors hover:text-[#5C8A1E]">How We Work</a></li>
            <li><a href="#workshop" className="text-sm text-[#586150] transition-colors hover:text-[#5C8A1E]">Executive Workshop</a></li>
          </ul>
        </div>
      </div>

      <div className="mt-12 flex flex-col items-center justify-between gap-4 border-t border-line pt-6 sm:flex-row">
        <p className="text-xs text-[#8e9882]">© {new Date().getFullYear()} XSELL Solutions — GTM & Revenue Consulting.</p>
        <p className="text-xs text-[#8e9882]">Your Partner in Growth — Big-4-caliber strategy, boutique focus.</p>
      </div>
    </div>
  </footer>
);
